import './productTile.scss'
import rightArrowIcon from '../../../../../../images/common/rightArrow.svg'
import { type Product } from '../../../../../../types/products/productTypes'
import { useGetOrderNameFromProduct } from 'components/product-order-popup/hooks/useGetOrderNameFromProduct'
import { useProductOrderContext } from 'components/product-order-popup/context'

interface Props {
  product: Product
  onClick: () => void
}
export const ProductTile = ({ product, onClick }: Props) => {
  const { isMoudPharmacyPickup, isMHTPharmacyPickup, isMoudHomeDelivery } = useProductOrderContext()
  const { getOrderNameFromProduct } = useGetOrderNameFromProduct({ isMoudHomeDelivery })

  const isPharmacyPickup = isMHTPharmacyPickup || isMoudPharmacyPickup
  return (
    <div role='presentation' className='product-type-tile-container' onClick={onClick}>
      <div className='product-type-tile-info'>
        <div className='bold'>{getOrderNameFromProduct(product)}</div>
        <div>{product.Duration}</div>
        {isPharmacyPickup || (product.PriceRange.From === product.PriceRange.To && product.PriceRange.From === 0) ? null
        : <div className='product-type-tile-description'>
            {product.PriceRange.From === product.PriceRange.To ?
              `$${Number(product.PriceRange.From.toFixed(2)).toLocaleString('en-US', {
                minimumFractionDigits: 2,
              })}`
            : `$${Number(product.PriceRange.From.toFixed(2)).toLocaleString('en-US', {
                minimumFractionDigits: 2,
              })} - $${Number(product.PriceRange.To.toFixed(2)).toLocaleString('en-US', {
                minimumFractionDigits: 2,
              })}`
            }
          </div>}
      </div>
      <img
        className='product-type-tile-right-arrow'
        role='presentation'
        src={rightArrowIcon}
        alt={`Select ${product.Name}`}
      />
    </div>
  )
}
